import { CUSTOM_REPORT_NUMBER_OF_ROWS } from '@app/components/LoggedIn/Reports/CustomReports/AddEditCustomReports/CustomReportsCreator/types';
import { IDashboardLayoutElement } from '@westondev/tableturn-core';

const numberOfRows = CUSTOM_REPORT_NUMBER_OF_ROWS;

export const isCustomReportElementInCorrectPage = (
  element: IDashboardLayoutElement,
) => {
  const page =
    element.y + element.h > numberOfRows
      ? Math.ceil((element.y + element.h) / numberOfRows)
      : 1;
  const startingRow = (page - 1) * numberOfRows + 1;
  const endingRow = page * numberOfRows;
  const isInCorrectPage =
    element.y + 1 >= startingRow && element.y + element.h <= endingRow;

  return { isInCorrectPage, startingRow: startingRow - 1 };
};
